<template>
    <section class="hero">
      <div class="overlay">
        <div class="content">
          <h1 class="main-title">{{ content.h1 }}</h1>
          <h3>{{ content.h3 }}</h3>
            <OpenModalButton/>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import OpenModalButton from '@/components/Buttons/OpenModalButton.vue'
 
  
  export default {
    name: "HeroBlockSection",
    components: {
      OpenModalButton
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    }
  };
  </script>



  